<template>
  <div class="toolbar">
    <div class="toolbar__left" v-if="$slots.left" :class="{'hide-on-mobile': hideLeftOnMobile}">
      <slot name="left"></slot>
    </div>
    <div class="toolbar__center">
      <slot name="center"></slot>
    </div>
    <div class="toolbar__right" v-if="$slots.right" :class="{'hide-on-mobile': hideRightOnMobile}">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Toolbar',
  props: {
    hideLeftOnMobile: {
      type: Boolean,
      default: true,
    },
    hideRightOnMobile: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.toolbar {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 10;
  padding: 0 30px;
  @media all and (max-width: 600px) {
    padding: 0 20px;
    max-width: 100%;
  }
  > div {
    display: flex;
    flex: 1;
    &.toolbar__left {
      font-weight: 500;
    }
    &.toolbar__center {
      justify-content: center;
      flex-basis: auto;
    }
    &.toolbar__right {
      justify-content: flex-end;
    }
  }
  @media all and (max-width: 700px) {
    position: relative;
    width: 100%;
    padding: 10px;
    display: block;
    div.hide-on-mobile {
      display: none;
    }
  }
}
</style>
